export default __webpack_public_path__ + "static/media/3.eaa75cf0.svg";